import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";
import { DescriptList } from "../../components/DescriptList";
import { Button } from "../../components/Button";
import { CommonConsult } from "../common-consult";
import { Link } from "../../components/LinkIcon";

export const AdContent = () => {
  const { t } = useTranslation();

  return (
    <div>
      <section>
        <div className="ad-content">
          <div className="inner">
            <div className="content">
              <div
                style={{
                  fontSize: 32,
                  textAlign: "center",
                  fontWeight: 500,
                  marginTop: 30,
                }}
              >
                {t("solution.buildAd.intro.item1.title")}
              </div>
              <div className="descriptWarp">
                <DescriptList
                  title={t("solution.buildAd.intro.item1.subtitle")}
                  data={[
                    {
                      title: t("solution.buildAd.intro.item1.descript1-title"),
                      titleDesc: t("solution.buildAd.intro.item1.descript1"),
                    },
                    {
                      title: t("solution.buildAd.intro.item1.descript2-title"),
                      titleDesc: t("solution.buildAd.intro.item1.descript2"),
                    },
                    {
                      title: t("solution.buildAd.intro.item1.descript3-title"),
                      titleDesc: t("solution.buildAd.intro.item1.descript3"),
                    },
                    {
                      title: t("solution.buildAd.intro.item1.descript4-title"),
                      titleDesc: t("solution.buildAd.intro.item1.descript4"),
                    },
                  ]}
                />
                <div className="ad-img ad-img-item1">
                  <img
                    src={
                      "//files.authing.co/authing-website/solution-ad-problem.png"
                    }
                    alt="AD 身份解决方案"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="ad-content" style={{ background: "#fafafa" }}>
          <div className="inner">
            <div className="content">
              <div className="descriptWarp">
                <div className="ad-img ad-img-item2">
                  <img
                    src={
                      "//files.authing.co/authing-website/solution-ad-process.png"
                    }
                    alt="AD 单点登录"
                  />
                </div>
                <DescriptList
                  title={t("solution.buildAd.intro.item2.title")}
                  data={[
                    {
                      title: t("solution.buildAd.intro.item2.descript1-title"),
                      titleDesc: t("solution.buildAd.intro.item2.descript1"),
                    },
                    {
                      title: t("solution.buildAd.intro.item2.descript2-title"),
                      titleDesc: t("solution.buildAd.intro.item2.descript2"),
                    },
                    {
                      title: t("solution.buildAd.intro.item2.descript3-title"),
                      titleDesc: t("solution.buildAd.intro.item2.descript3"),
                    },
                    {
                      title: t("solution.buildAd.intro.item2.descript4-title"),
                      titleDesc: t("solution.buildAd.intro.item2.descript4"),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="ad-content">
          <div className="inner">
            <div className="content">
              <div className="descriptWarp">
                <div>
                  <DescriptList
                    title={t("solution.buildAd.intro.item3.title")}
                    data={[
                      {
                        titleDesc: t("solution.buildAd.intro.item3.descript1"),
                      },
                      {
                        titleDesc: t("solution.buildAd.intro.item3.descript2"),
                      },
                    ]}
                  />
                  <CommonConsult
                    aside={
                      <Button style={{ marginTop: 30, float: "left" }}>
                        {t("common.button.consult")}
                      </Button>
                    }
                    fromTag="ad"
                  />
                  <Link
                    href="https://docs.authing.cn/v2/guides/connections/enterprise/windows-ad/"
                    target="_blank"
                    style={{
                      position: "relative",
                      left: 40,
                      top: 43,
                    }}
                  >
                    {t("learn.common.check-doc")}
                  </Link>
                </div>
                <div className="ad-img ad-img-item3">
                  <img
                    src={
                      "//files.authing.co/authing-website/solution-ad-security.png"
                    }
                    alt="AD 身份验证"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
